<!-- <div class="row">
    <div class="col-sm-2">
        <mat-card class="card cont">
            Finalizados
            <mat-card-content class="cont">2</mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-2">
        <mat-card class="card cont">
            Registrados
            <mat-card-content>2</mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-2">
        <mat-card class="card cont">
            Pendentes
            <mat-card-content>3</mat-card-content>
        </mat-card>
    </div>
</div> -->

<div class="row">
  <div class="col">
    <h1>Coleta</h1>
  </div>
</div>

<div class="row mt-4">
  <div class="col-sm">
    <mat-form-field style="margin-top: 1rem">
      <input
        #input
        matInput
        autocomplete="off"
        placeholder="Pesquisar por Código da coleta, Cliente ou CPF"
        [value]="store.pageSearch"
      />
    </mat-form-field>
  </div>
</div>
<div class="row mt-4">
  <div class="col-sm">
    <button
      style="background-color: green"
      (click)="openCPFBusca()"
      mat-mini-fab
      title="Adicionar Coleta"
    >
      <mat-icon class="mat-icon">add</mat-icon>
    </button>
  </div>
</div>

<div class="row mt-4">
  <div class="col-sm">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="table-full">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Código da Coleta</th>
          <td mat-cell *matCellDef="let captacoes">
            {{ captacoes.coletor.codigo }}
            <!-- <div *ngIf="!!captacoes.editarWeb">
                        {{captacoes.coletor.codigo}}
                      </div> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left"
            (click)="ordenar()"
            class="pointer"
          >
            Cliente
          </th>
          <td mat-cell *matCellDef="let captacoes" class="text-left">
            {{ captacoes.doador.nome }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cpf">
          <th mat-header-cell *matHeaderCellDef class="text-center">CPF</th>
          <td mat-cell *matCellDef="let captacoes" class="text-center">
            {{ captacoes.doador.cpf }}
          </td>
        </ng-container>

        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Data da Coleta
          </th>
          <td mat-cell *matCellDef="let captacoes" class="text-center">
            {{ formatarData(captacoes.dataColeta) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="finalizado">
          <th mat-header-cell *matHeaderCellDef class="text-right">Situação</th>
          <td
            mat-cell
            *matCellDef="let captacoes"
            class="text-right"
            [ngClass]="captacoes.editarWeb === '0' ? 'ok' : 'error'"
          >
            {{ statusColeta(captacoes.editarWeb) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="editar">
          <th mat-header-cell *matHeaderCellDef class="text-right">Editar</th>
          <td
            mat-cell
            *matCellDef="let captacoes"
            class="pointer"
            class="text-right"
          >
            <a
              routerLink="/captacao/{{ captacoes.coletor.codigo }}"
              title="Editar Captação"
              ><mat-icon>edit</mat-icon></a
            >
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunas"></tr>
        <tr mat-row *matRowDef="let row; columns: colunas"></tr>
      </table>

      <mat-paginator
        [pageIndex]="store.pageIndex"
        [pageSizeOptions]="pageSizeArray"
        [pageSize]="[store.pageSize]"
        [length]="store.pageLenght"
        (page)="getNext($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
